// import LogRocket from "logrocket";

type LogLevelType = "debug" | "error" | "info" | "log" | "warn";

const Logger = (logLevel: LogLevelType, ...args: any) => {
  // disable logrocket
  // if (process.env.NODE_ENV === "production") {
  //   LogRocket[logLevel](...args);
  // } else {
  // window.console[logLevel](...args);
  // }
  window.console[logLevel](...args);
};

export default Logger;
